// src/pages/PaymentFailed.jsx
import React from "react";
import { Link } from "react-router-dom";

const PaymentFailed = () => {
  return (
    <section className="flex items-center justify-center   bg-red-50">
      <div className="text-center bg-white p-10 rounded-2xl shadow-md">
        <h1 className="text-3xl font-bold text-red-600">❌ Payment Failed!</h1>
        <p className="mt-4 text-gray-700">
          Something went wrong with your payment. Please try again.
        </p>
        <Link
          to="/pricing"
          className="mt-6 inline-block bg-red-500 text-white px-6 py-3 rounded-lg hover:bg-red-600"
        >
          Back to Pricing
        </Link>
      </div>
    </section>
  );
};

export default PaymentFailed;
